{
	"backToStartPage": "Torna alla pagina iniziale",
	"transactionDetailsTitle": "Dettagli transazione",
	"btnVerifyTransactions": "Verifica transazioni",
	"kpi": {
		"date": "Date",
		"quantity": "Quantità",
		"carbonReductions": "Riduzioni di carbonio"
	},
	"verifyTransactionModal": {
		"title": "Verifica transazione",
		"description": "Inserisci il Record ID per questa transazione. Puoi trovare l’informazione sulla dichiarazione.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Annulla",
		"verifyTitle": "Verifica",
		"errors": {
			"recordIdRequired": "Il Record ID è obbligatorio",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "Impossibile verificare la transazione. Controlla il Record ID"
		}
	},
	"errors": {
		"notFound": "Transazione non trovata"
	}
}
